import axiosHttp from "./interceptor.service";
import { encryptData } from "../utils/cryptoUtils";

const postUser = (data) => {
  return axiosHttp.post("/lmt/register", data);
};
const loginApi = (data) => {
  return axiosHttp.post("/lmt/login", data);
};

const getTokenbyData = () => {
  return axiosHttp.get("/lmt/tokenData");
};

const getUserById = (id, { month, year } = {}) => {
  console.log("id", id);
  return axiosHttp.get(`/lmt/getUser/${id}`, { params: { month, year } });
};

const getUser = ({ isEnabled, project, search, page, limit, isManager, isAdmin } = {}) => {
  return axiosHttp.get("/lmt/getUser", {
    params: { isEnabled, project, search, page, limit, isManager, isAdmin },
  });
};

const deleteEmployee = (id, data) => {
  return axiosHttp.delete(`/lmt/deleteUser/${id}`, data);
};

const updateEmployee = (id, data) => {
  return axiosHttp.put(`/lmt/updateUser/${id}`, data);
};

const changePassword = (id, data) => {
  return axiosHttp.post(`/lmt/resetPassword/${id}`, data);
};

const newPassword = (id, data) => {
  return axiosHttp.post(`/lmt/newPassword/${id}`, data);
};

// Manager Service
const getManager = ({ isEnabled, project, search, page, limit } = {}) => {
  return axiosHttp.get("/lmt/getManager", {
    params: { isEnabled, project, search, page, limit },
  });
};

const deleteManager = (id, data) => {
  return axiosHttp.delete(`/lmt/deleteManager/${id}`, data);
};

const updateManager = (id, data) => {
  return axiosHttp.put(`/lmt/updateManager/${id}`, data);
};

// Get all users for permission management
const getAllUsers = (query) => {
  const encryptedQuery = {
    isAdmin: query.isAdmin,
    search: encryptData(query.search || ""),
    page: encryptData(query.page),
    limit: encryptData(query.limit),
    isManager: query.isManager ? encryptData(query.isManager) : undefined,
  };
  return axiosHttp.get("/lmt/getUser", { params: encryptedQuery });
};

export {
  postUser,
  loginApi,
  getTokenbyData,
  getUserById,
  getUser,
  getAllUsers,
  deleteEmployee,
  updateEmployee,
  changePassword,
  newPassword,
  deleteManager,
  updateManager,
  getManager
};
